import React, {useState} from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { ImUser } from 'react-icons/im';
import { BiPlus } from 'react-icons/bi';
import RunningTrackNavBar from './RunningTrackNavBar';
import AdsBox from './AdsBox';
import RunningTrackArtAdsComponent from './RunningTrackArtAdsComponent';

const Wrapper = styled.div`
  padding: 20px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
`;

const AdsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const AddButton = styled.div`
  width: 160px;
  height: 144px;
  border-radius: 8px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #e0e0e0;
  }
`;

const RunningTrackAdsComponent = ({mainAds, bannerAds, sideAds, onDelete, onAdd, onEdit}) => {
    const handleAdd = (type) => {
        onAdd(type);
    };
    const handleDelete = (id) => {
        console.log('handleDelete : ', id)
      onDelete(id);
    };
  return (
    <Wrapper>
        {/* 트랙 광고판(미디어아트) — 테마 + 한 줄 문구. 아래 이미지 광고 3종은 그대로 둔다(side 는 대기화면이 아직 쓴다). */}
        <RunningTrackArtAdsComponent />

        <Section>
            <SectionTitle>티비앱</SectionTitle>
            <AdsContainer>
                {bannerAds.map(ad => (
                <AdsBox 
                    key={ad.runningTrackAdsID}
                    adsId={ad.runningTrackAdsID}
                    url={ad.url}
                    adsType={ad.adsType}
                    fileType={ad.fileType}
                    duration={ad.time}
                    onDelete={() => handleDelete(ad.runningTrackAdsID)}
                    onEdit={onEdit}
                />
                ))}
                <AddButton onClick={() => handleAdd('banner')}>
                    <BiPlus />
                </AddButton>
            </AdsContainer>
        </Section>

        <Section>
            <SectionTitle>런닝머신앱 대기화면</SectionTitle>
            <AdsContainer>
                {mainAds.map(ad => (
                <AdsBox 
                    key={ad.runningTrackAdsID}
                    adsId={ad.runningTrackAdsID}
                    url={ad.url}
                    adsType={ad.adsType}
                    fileType={ad.fileType}
                    duration={ad.time}
                    onDelete={() => handleDelete(ad.runningTrackAdsID)}
                    onEdit={onEdit}
                />
                ))}
                <AddButton onClick={() => handleAdd('main')}>
                    <BiPlus />
                </AddButton>
            </AdsContainer>
        </Section>

        <Section>
            <SectionTitle>런닝머신앱 운동장</SectionTitle>
            <AdsContainer>
                {sideAds.map(ad => (
                <AdsBox 
                    key={ad.runningTrackAdsID}
                    adsId={ad.runningTrackAdsID}
                    url={ad.url}
                    adsType={ad.adsType}
                    fileType={ad.fileType}
                    duration={ad.time}
                    onDelete={() => handleDelete(ad.runningTrackAdsID)}
                    onEdit={onEdit}
                />
                ))}
                <AddButton onClick={() => handleAdd('side')}>
                    <BiPlus />
                </AddButton>
            </AdsContainer>
        </Section>
    </Wrapper>
  );
};

export default RunningTrackAdsComponent;
